import { useEffect, useState } from "react";
import "./Home.css";
import { FaGear } from "react-icons/fa6";
import { FiActivity } from "react-icons/fi";
import { FiPieChart } from "react-icons/fi";
import Table from "../../components/table/Table";
import Header from "../../components/Header";
import ReplicationChart from "../../components/chart/ReplicationChart";
import IntegrationsChart from "../../components/chart/IntegrationsChart";
import "../../styles/Chart.css";
import Box from "@mui/material/Box";
import {getDateRange} from '../../helper'
import {
  fetchTableData,
  fetchIntegrationsData,
  fetchReplicationData,
} from "../../api/dashboardApi"; 


function Home() {
  const [refresh, setRefresh] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [integrationsData, setIntegrationsData] = useState([]);
  const [replicationData, setReplicationData] = useState([]);
  const [replicationPeriod, setReplicationPeriod] = useState("Last month");
  const [replicationPanel, setReplicationPanel] = useState("Replication events"); 
  const [integrationsPeriod, setIntegrationsPeriod] = useState("Last month"); 
  const { startDate, endDate } = getDateRange('Last month');
  const [filter, setFilter] = useState({
    dashboardId: "degijznwz979cc",
    panelId: "API Events - Table",
    startDate,
    endDate,
    interval: "1h",
  });

  const handleReplicationPanelChange = (e) => {
    const panel = e.target.value;
    setReplicationPanel(panel);
    setFilter((prev) => ({
      ...prev,
      panelId:panel
    }));
  };
  const handleReplicationPeriodChange = (e) => {
    const period = e.target.value;
    setReplicationPeriod(period);
  
    const { startDate, endDate } = getDateRange(period);
    setFilter((prev) => ({
      ...prev,
      startDate,
      endDate,
    }));
  };

  const handleIntegrationsPeriodChange = (e) => {
    const period = e.target.value;
    setIntegrationsPeriod(period);
    const { startDate, endDate } = getDateRange(period);
    setFilter((prev) => ({
      ...prev,
      startDate,
      endDate,
    }));
  };

  useEffect(() => {
    setLoading(true)
    fetchTableData(filter)
      .then((res) => setData(res.data.reverse()))
      .catch((err) => {
        setData([]);
        console.error("Error fetching table data:", err);
      })
      .finally(()=>setLoading(false));
  }, [refresh]);

  useEffect(()=>{
    fetchIntegrationsData(filter)
    .then((res) => setIntegrationsData(res.data))
    .catch((err) => {
      setIntegrationsData([]);
      console.error("Error fetching integrations data:", err);
    });
  },[integrationsPeriod])

  useEffect(()=>{
    fetchReplicationData(filter ,replicationPanel)
      .then((res) => setReplicationData(res.data))
      .catch((err) => {
        setReplicationData([]);
        console.error("Error fetching replication data:", err);
      });
  },[replicationPeriod,replicationPanel])

  return (
    <div className="layout">
      <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="sidebar-icons">
          <button  aria-label="dashboard" className="sidebar-icon active">
            <FiActivity />
          </button>
          <button  aria-label="chart" className="sidebar-icon">
            <FiPieChart />
          </button>
          <button  aria-label="setting" className="sidebar-icon">
            <FaGear />
          </button>
        </div>
      </div>

      <main className="main-content">
        <Box
          sx={{
            marginBottom: "20px",
          }}
        >
          <h1 className="dashboard-title">Dashboard</h1>
          <div className="chart-box-content">
            <div className="chart-container">
              <div className="chart-header">
                <h2>{replicationPanel}</h2>
                <Box sx={{
                  display:"flex",
                  gap:"10px"
                }}>

                <select
                  value={replicationPanel}
                  onChange={handleReplicationPanelChange}
                  className="period-select"
                >
                  <option>Replication events</option>
                  <option>Event replication - Durations (Avg)</option>
                  <option>Event replication - Durations (Max)</option>
                  <option>SQL Statements - Durations (Max)</option>
                  <option>API Events - Avg duration</option>
                </select>
                <select
                  value={replicationPeriod}
                  onChange={handleReplicationPeriodChange}
                  className="period-select"
                >
                  <option>Last week</option>
                  <option>Last month</option>
                  <option>Last quarter</option>
                  <option>Last year</option>
                </select>
                </Box>
              </div>
              <ReplicationChart chartData={replicationData} loading={loading} />
            </div>

            <div className="chart-container">
              <div className="chart-header">
                <h2>Avg Duration Chart</h2>
                <select
                  value={integrationsPeriod}
                  onChange={handleIntegrationsPeriodChange}
                  className="period-select"
                >
                  <option>Last week</option>
                  <option>Last month</option>
                  <option>Last quarter</option>
                  <option>Last year</option>
                </select>
              </div>
              <IntegrationsChart chartData={integrationsData} loading={loading} />
            </div>
          </div>
        </Box>
        <Box>
          <Table 
            data={data} 
            filter={filter} 
            setFilter={setFilter}
            setRefresh={setRefresh} 
            loading={loading} />
        </Box>
      </main>
    </div>
  );
}

export default Home;
